import React from "react";
import Convert from "../../common/Convert";
import InputBase from "./InputBase";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import {
    Label
} from "reactstrap";

export default class InputSelect extends InputBase {
    static defaultProps = {
        label:'',
        labelOn:false,
        name:'',
        className:'',
        style:{},
        options:[],
        rootData:{
            values:{},
            errors:{},
            requiredData:{}
        },
        isSearchable:false,
        enterSearchFlag: false,
        zIndex: 9999,
    }

    constructor(props) {
        super(props);
        this.selfDom = React.createRef();  // React.createRef() を明示的に使用
        this.handle_change = this.handle_change.bind(this)
    }

    handle_change(value) {
        const trimmedValue = this.trim(value)

        this.validate(trimmedValue)
    }

    enterSearch(e){
        const ENTER = 13;
        if(this.props.enterSearchFlag == false){
            return
        }
        if (e.keyCode == ENTER) {
            if(this.selfDom.current.state.menuIsOpen){
                return;
            }
            this.props.enterCallback&&this.props.enterCallback();
        }
    }

    render() {
        const{
            disabled,
            name,
            label,
            labelOn,
            rootData:{
                // requiredData,
                errors,
                values
            },
            options,
            className,
            // style,
            isSearchable,
            isCreatable,
            isClearable=true,
            searchStartLength = 0,
            menuPosition,
            zIndex,
        } = this.props
        const columnObject = Convert.key_split(name)
        const value = values&&values[columnObject.column]
        const validate_message = errors&&errors[columnObject.column]
        const findValue = options.find((option)=>option.value==value);

        const filterOptions = (candidate, input) => {
            if (searchStartLength !== 0 && input.length < searchStartLength) {
                return false
            } else {
                return candidate.label.toLowerCase().includes(input.toLowerCase())
            }
        };
        let defualtValue = options.find((option)=>option.value==value)
        return (
            
            <>
                {
                    labelOn &&
                    <Label for={name} className="search-text-order">
                        {label}
                        ：
                    </Label>
                }
                {
                    isCreatable
                    ?<CreatableSelect
                    ref={this.selfDom}
                    key={name}
                    formatCreateLabel={(value)=>`"${value}"を入力`}
                    isDisabled={disabled} 
                    className={`searchable-select ${className} tabable`} 
                    isSearchable={isSearchable} 
                    onChange={(option)=>this.handle_change(option&&option.value)} 
                    placeholder={`${label}を選択してください`} 
                    value={findValue || value && {label : value}}
                    options={options}
                    createOptionPosition="first"
                    isClearable={isClearable}
                    menuPosition={menuPosition}
                    styles={{
                        input: styles => ({ 
                            ...styles
                            , maxWidth: 0
                         }),
                         menu: provided => ({ ...provided, zIndex: 9999 })
                    }}
                    onKeyDown={(e) => this.enterSearch(e)} 
                    filterOption={filterOptions}
                    />
                    :<Select
                    ref={this.selfDom}
                    key={name}
                    isDisabled={disabled} 
                    className={`searchable-select ${className} tabable`} 
                    isSearchable={isSearchable} 
                    onChange={(option)=>this.handle_change(option&&option.value)} 
                    placeholder={`${label}を選択してください`} 
                    value={defualtValue==undefined?null:defualtValue} 
                    defaultValue={defualtValue==undefined?null:defualtValue} 
                    options={options}
                    isClearable={isClearable}
                    menuPosition={menuPosition}
                    styles={{
                        menu: provided => ({
                            ...provided,
                            zIndex: this.props.zIndex,
                            maxWidth: "200px",
                            pointerEvents: "auto",
                        })
                    }}
                    {...(this.props.inTable ? {menuPortalTarget : document.body, menuPosition : 'fixed'}:{})}
                    filterOption={filterOptions}
                    />
                }
                {
                    validate_message instanceof Array && validate_message.length>0 &&
                    <p id={name} style={{ color: "red" }}>{validate_message.length>0?validate_message[0]:validate_message}</p>
                }
            </>
        );
    }
}
